// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/ico-close.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#fancybox-loading{
	position: fixed;
	top:50%;
	left:50%;
	width:40px;
	height:40px;
	margin-top:-20px;
	margin-left:-20px;
	cursor:pointer;
	overflow:hidden;
	z-index:1104;
	display:none;
}
#fancybox-loading div{
	position:absolute;
	top:0;
	left:0;
	width:40px;
	height:480px;
	/*background-image:url(../images.png);*/
}
#fancybox-overlay{
	position:absolute;
	top:0;
	left:0;
	width:100%;
	z-index:1100;
	display:none;
}
#fancybox-tmp{
	padding:0;
	margin:0;
	border:0;
	overflow:auto;
	display:none;
}
#fancybox-wrap{
	position:absolute;
	top:0;
	left:0;
	padding:20px;
	z-index:1101;
	outline:none;
	display:none;
}
#fancybox-outer{
	position:relative;
	width:100%;
	height:100%;
}
#fancybox-content{
	width:0;
	height:0;
	padding:0;
	outline:none;
	position:relative;
	overflow:hidden;
	z-index:1102;
	border:0px solid #fff;
}
#fancybox-hide-sel-frame{
	position:absolute;
	top:0;
	left:0;
	width:100%;
	height: 00%;
	background:transparent;
	z-index:1101;
}
#fancybox-close{
	position:absolute;
	top:-14px;
	right:-55px;
	width:62px;
	height:61px;
	background:transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	cursor:pointer;
	z-index:1103;
	display:none;
}
#fancybox-error{
	color:#444;
	font:normal 12px/20px Arial;
	padding:14px;
	margin:0;
}
#fancybox-img{
	width:100%;
	height:100%;
	padding:0;
	margin:0;
	border:none;
	outline:none;
	line-height:0;
	vertical-align:top;
}
#fancybox-frame{
	width:100%;
	height:100%;
	border:none;
	display:block;
}
#fancybox-left, #fancybox-right {
	position: absolute;
	bottom: 0px;
	height: 100%;
	width: 35%;
	cursor: pointer;
	outline: none;
	/*background: transparent url(../images/blank.gif);*/
	z-index: 1102;
	display: none;
}
#fancybox-left {
	left: 0px;
}
#fancybox-right {
	right: 0px;
}
#fancybox-left-ico, #fancybox-right-ico {
	position: absolute;
	top: 50%;
	left: -9999px;
	width: 30px;
	height: 30px;
	margin-top: -15px;
	cursor: pointer;
	z-index: 1102;
	display: block;
}
#fancybox-left-ico {
	/*background-image: url(../images.png);*/
	background-position: -40px -30px;
}
#fancybox-right-ico {
	/*background-image: url(../images.png);*/
	background-position: -40px -60px;
}
#fancybox-left:hover span {
	left: 20px;
}
#fancybox-right:hover span {
	left: auto;
	right: 20px;
}
#fancybox-title {
	font-family: Helvetica;
	font-size: 12px;
	z-index: 1102;
}
.fancybox-title-inside {
	padding-bottom: 10px;
	text-align: center;
	color: #333;
	background: #fff;
	position: relative;
}
.fancybox-title-outside {
	padding-top: 10px;
	color: #fff;
}
.fancybox-title-over {
	position: absolute;
	bottom: 0;
	left: 0;
	color: #FFF;
	text-align: left;
}
#fancybox-title-over {
	padding: 10px;
	/*background-image: url(../images/fancy_title_over.png);*/
	display: block;
}
.fancybox-title-float {
	position: absolute;
	left: 0;
	bottom: -20px;
	height: 32px;
}
#fancybox-title-float-wrap {
	border: none;
	border-collapse: collapse;
	width: auto;
}
#fancybox-title-float-wrap td {
	border: none;
	white-space: nowrap;
}
#fancybox-title-float-left {
	padding: 0 0 0 15px;
	/*background: url(../images.png) -40px -90px no-repeat;*/
}
#fancybox-title-float-main {
	color: #FFF;
	line-height: 29px;
	font-weight: bold;
	padding: 0 0 3px 0;
	/*background: url(../images-x.png) 0px -40px;*/
}
#fancybox-title-float-right {
	padding: 0 0 0 15px;
	/*background: url(../images.png) -55px -90px no-repeat;*/
}
/* IE6, IE7, IE8 */
.fancybox-ie .fancybox-bg { background: transparent !important; }
.fancybox-ie #fancybox-bg-n { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_n.png', sizingMethod='scale'); }
.fancybox-ie #fancybox-bg-ne { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_ne.png', sizingMethod='scale'); }
.fancybox-ie #fancybox-bg-e { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_e.png', sizingMethod='scale'); }
.fancybox-ie #fancybox-bg-se { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_se.png', sizingMethod='scale'); }
.fancybox-ie #fancybox-bg-s { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_s.png', sizingMethod='scale'); }
.fancybox-ie #fancybox-bg-sw { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_sw.png', sizingMethod='scale'); }
.fancybox-ie #fancybox-bg-w { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_w.png', sizingMethod='scale'); }
.fancybox-ie #fancybox-bg-nw { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_nw.png', sizingMethod='scale'); }`, "",{"version":3,"sources":["webpack://./src/styles/fancybox.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,OAAO;CACP,QAAQ;CACR,UAAU;CACV,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,YAAY;CACZ,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,KAAK;CACL,MAAM;CACN,UAAU;CACV,YAAY;CACZ,uCAAuC;AACxC;AACA;CACC,iBAAiB;CACjB,KAAK;CACL,MAAM;CACN,UAAU;CACV,YAAY;CACZ,YAAY;AACb;AACA;CACC,SAAS;CACT,QAAQ;CACR,QAAQ;CACR,aAAa;CACb,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,KAAK;CACL,MAAM;CACN,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;AACZ;AACA;CACC,OAAO;CACP,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,YAAY;CACZ,qBAAqB;AACtB;AACA;CACC,iBAAiB;CACjB,KAAK;CACL,MAAM;CACN,UAAU;CACV,WAAW;CACX,sBAAsB;CACtB,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,SAAS;CACT,WAAW;CACX,UAAU;CACV,WAAW;CACX,8DAAmD;CACnD,cAAc;CACd,YAAY;CACZ,YAAY;AACb;AACA;CACC,UAAU;CACV,2BAA2B;CAC3B,YAAY;CACZ,QAAQ;AACT;AACA;CACC,UAAU;CACV,WAAW;CACX,SAAS;CACT,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,UAAU;CACV,WAAW;CACX,WAAW;CACX,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,eAAe;CACf,aAAa;CACb,oDAAoD;CACpD,aAAa;CACb,aAAa;AACd;AACA;CACC,SAAS;AACV;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,aAAa;CACb,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,cAAc;AACf;AACA;CACC,wCAAwC;CACxC,gCAAgC;AACjC;AACA;CACC,wCAAwC;CACxC,gCAAgC;AACjC;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,sBAAsB;CACtB,eAAe;CACf,aAAa;AACd;AACA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,yDAAyD;CACzD,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,aAAa;CACb,YAAY;AACb;AACA;CACC,YAAY;CACZ,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,mBAAmB;CACnB,wDAAwD;AACzD;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,8CAA8C;AAC/C;AACA;CACC,mBAAmB;CACnB,wDAAwD;AACzD;AACA,kBAAkB;AAClB,4BAA4B,kCAAkC,EAAE;AAChE,8BAA8B,iHAAiH,EAAE;AACjJ,+BAA+B,kHAAkH,EAAE;AACnJ,8BAA8B,iHAAiH,EAAE;AACjJ,+BAA+B,kHAAkH,EAAE;AACnJ,8BAA8B,iHAAiH,EAAE;AACjJ,+BAA+B,kHAAkH,EAAE;AACnJ,8BAA8B,iHAAiH,EAAE;AACjJ,+BAA+B,kHAAkH,EAAE","sourcesContent":["#fancybox-loading{\r\n\tposition: fixed;\r\n\ttop:50%;\r\n\tleft:50%;\r\n\twidth:40px;\r\n\theight:40px;\r\n\tmargin-top:-20px;\r\n\tmargin-left:-20px;\r\n\tcursor:pointer;\r\n\toverflow:hidden;\r\n\tz-index:1104;\r\n\tdisplay:none;\r\n}\r\n#fancybox-loading div{\r\n\tposition:absolute;\r\n\ttop:0;\r\n\tleft:0;\r\n\twidth:40px;\r\n\theight:480px;\r\n\t/*background-image:url(../images.png);*/\r\n}\r\n#fancybox-overlay{\r\n\tposition:absolute;\r\n\ttop:0;\r\n\tleft:0;\r\n\twidth:100%;\r\n\tz-index:1100;\r\n\tdisplay:none;\r\n}\r\n#fancybox-tmp{\r\n\tpadding:0;\r\n\tmargin:0;\r\n\tborder:0;\r\n\toverflow:auto;\r\n\tdisplay:none;\r\n}\r\n#fancybox-wrap{\r\n\tposition:absolute;\r\n\ttop:0;\r\n\tleft:0;\r\n\tpadding:20px;\r\n\tz-index:1101;\r\n\toutline:none;\r\n\tdisplay:none;\r\n}\r\n#fancybox-outer{\r\n\tposition:relative;\r\n\twidth:100%;\r\n\theight:100%;\r\n}\r\n#fancybox-content{\r\n\twidth:0;\r\n\theight:0;\r\n\tpadding:0;\r\n\toutline:none;\r\n\tposition:relative;\r\n\toverflow:hidden;\r\n\tz-index:1102;\r\n\tborder:0px solid #fff;\r\n}\r\n#fancybox-hide-sel-frame{\r\n\tposition:absolute;\r\n\ttop:0;\r\n\tleft:0;\r\n\twidth:100%;\r\n\theight: 00%;\r\n\tbackground:transparent;\r\n\tz-index:1101;\r\n}\r\n#fancybox-close{\r\n\tposition:absolute;\r\n\ttop:-14px;\r\n\tright:-55px;\r\n\twidth:62px;\r\n\theight:61px;\r\n\tbackground:transparent url(../images/ico-close.png);\r\n\tcursor:pointer;\r\n\tz-index:1103;\r\n\tdisplay:none;\r\n}\r\n#fancybox-error{\r\n\tcolor:#444;\r\n\tfont:normal 12px/20px Arial;\r\n\tpadding:14px;\r\n\tmargin:0;\r\n}\r\n#fancybox-img{\r\n\twidth:100%;\r\n\theight:100%;\r\n\tpadding:0;\r\n\tmargin:0;\r\n\tborder:none;\r\n\toutline:none;\r\n\tline-height:0;\r\n\tvertical-align:top;\r\n}\r\n#fancybox-frame{\r\n\twidth:100%;\r\n\theight:100%;\r\n\tborder:none;\r\n\tdisplay:block;\r\n}\r\n#fancybox-left, #fancybox-right {\r\n\tposition: absolute;\r\n\tbottom: 0px;\r\n\theight: 100%;\r\n\twidth: 35%;\r\n\tcursor: pointer;\r\n\toutline: none;\r\n\t/*background: transparent url(../images/blank.gif);*/\r\n\tz-index: 1102;\r\n\tdisplay: none;\r\n}\r\n#fancybox-left {\r\n\tleft: 0px;\r\n}\r\n#fancybox-right {\r\n\tright: 0px;\r\n}\r\n#fancybox-left-ico, #fancybox-right-ico {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: -9999px;\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tmargin-top: -15px;\r\n\tcursor: pointer;\r\n\tz-index: 1102;\r\n\tdisplay: block;\r\n}\r\n#fancybox-left-ico {\r\n\t/*background-image: url(../images.png);*/\r\n\tbackground-position: -40px -30px;\r\n}\r\n#fancybox-right-ico {\r\n\t/*background-image: url(../images.png);*/\r\n\tbackground-position: -40px -60px;\r\n}\r\n#fancybox-left:hover span {\r\n\tleft: 20px;\r\n}\r\n#fancybox-right:hover span {\r\n\tleft: auto;\r\n\tright: 20px;\r\n}\r\n#fancybox-title {\r\n\tfont-family: Helvetica;\r\n\tfont-size: 12px;\r\n\tz-index: 1102;\r\n}\r\n.fancybox-title-inside {\r\n\tpadding-bottom: 10px;\r\n\ttext-align: center;\r\n\tcolor: #333;\r\n\tbackground: #fff;\r\n\tposition: relative;\r\n}\r\n.fancybox-title-outside {\r\n\tpadding-top: 10px;\r\n\tcolor: #fff;\r\n}\r\n.fancybox-title-over {\r\n\tposition: absolute;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tcolor: #FFF;\r\n\ttext-align: left;\r\n}\r\n#fancybox-title-over {\r\n\tpadding: 10px;\r\n\t/*background-image: url(../images/fancy_title_over.png);*/\r\n\tdisplay: block;\r\n}\r\n.fancybox-title-float {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\tbottom: -20px;\r\n\theight: 32px;\r\n}\r\n#fancybox-title-float-wrap {\r\n\tborder: none;\r\n\tborder-collapse: collapse;\r\n\twidth: auto;\r\n}\r\n#fancybox-title-float-wrap td {\r\n\tborder: none;\r\n\twhite-space: nowrap;\r\n}\r\n#fancybox-title-float-left {\r\n\tpadding: 0 0 0 15px;\r\n\t/*background: url(../images.png) -40px -90px no-repeat;*/\r\n}\r\n#fancybox-title-float-main {\r\n\tcolor: #FFF;\r\n\tline-height: 29px;\r\n\tfont-weight: bold;\r\n\tpadding: 0 0 3px 0;\r\n\t/*background: url(../images-x.png) 0px -40px;*/\r\n}\r\n#fancybox-title-float-right {\r\n\tpadding: 0 0 0 15px;\r\n\t/*background: url(../images.png) -55px -90px no-repeat;*/\r\n}\r\n/* IE6, IE7, IE8 */\r\n.fancybox-ie .fancybox-bg { background: transparent !important; }\r\n.fancybox-ie #fancybox-bg-n { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_n.png', sizingMethod='scale'); }\r\n.fancybox-ie #fancybox-bg-ne { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_ne.png', sizingMethod='scale'); }\r\n.fancybox-ie #fancybox-bg-e { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_e.png', sizingMethod='scale'); }\r\n.fancybox-ie #fancybox-bg-se { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_se.png', sizingMethod='scale'); }\r\n.fancybox-ie #fancybox-bg-s { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_s.png', sizingMethod='scale'); }\r\n.fancybox-ie #fancybox-bg-sw { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_sw.png', sizingMethod='scale'); }\r\n.fancybox-ie #fancybox-bg-w { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_w.png', sizingMethod='scale'); }\r\n.fancybox-ie #fancybox-bg-nw { filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='images/fancy_shadow_nw.png', sizingMethod='scale'); }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
